import React from 'react';

//Styles
import Styles from './CircleCheck.module.scss';

const CircleCheck = ({color = '#B3BDC8', size = 18, checked = false}) => (
    <div className={Styles.check} style={{
        width: size,
        height: size,
        borderColor: color
    }}>
        {checked && (
            <div className={Styles.checked} style={{
                width: size / 2 - 1,
                height: size / 2 - 1,
                backgroundColor: color
            }}/>
        )}
    </div>
);

export default CircleCheck